import { createContext, useContext } from 'react';

export const ToolAccessContext = createContext({
    tools: [],
    accessMap: {},
    primaryToolKey: 'Logic',
    isSuperAdmin: false,
    isRootAdmin: false,
    isMember: true,
    accessReady: false,
    canEditCurrent: true,
    currentToolKey: 'Dashboard',
    pinTool: async () => {},
    unpinTool: async () => {},
    refresh: async () => {},
    refreshAccess: async () => {}
});

export function useToolAccess() {
    return useContext(ToolAccessContext);
}
